import { FC, PropsWithChildren, useEffect } from 'react'
import { useVerification } from 'src/common/api'

export const AuthCodeWrapper: FC<PropsWithChildren> = ({ children }) => {
  const urlParams = new URLSearchParams(window.location.search)
  const authCode = urlParams.get('c')
  if (authCode) {
    urlParams.delete('c')
  }
  const shouldValidateCode = Boolean(authCode)
  const { isSuccess, isError } = useVerification({ authCode }, shouldValidateCode)

  useEffect(() => {
    if (isError) {
      history.replaceState(null, 'HealthHelper', '/auth/link/resend')
      location.reload()
    }
  }, [isError])

  if (shouldValidateCode && !isSuccess) {
    return null
  }

  return <>{children}</>
}
